import { ChangeDetectionStrategy, Component, effect, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { ClientService } from '@dss-libs/shared/data-access/clients';
import { LoaderService, SnackbarService } from '@dss-libs/shared/utility/common-services';
import { EventTypeEnum, SubscriptionStatus } from '@dss-libs/shared/type/common-types';
@Component({
  selector: 'dss-libs-feature-subscription-in-progress',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubscriptionInProgressComponent {
  readonly #router = inject(Router);
  readonly #clientService = inject(ClientService);
  readonly #loaderService = inject(LoaderService);
  readonly #snackbarService = inject(SnackbarService);
  readonly #clientDataResource = this.#clientService.clientDataResource;
  readonly #pollAttempt = signal(0);

  readonly MAX_SUBSCRIPTION_POLL_RELOADS = 60;
  readonly SUBSCRIPTION_POLL_INTERVAL_MS = 1_000;

  constructor() {
    this.#clientService.inviteEmailsSavedLocally().subscribe({
      error: () => {
        this.#snackbarService.showToaster(EventTypeEnum.ERROR, 'SETTINGS.INVITE_MEMBERS_ERROR');
        void this.#router.navigate(['/orders']);
      },
    });

    effect((onCleanup) => {
      const pollAttempt = this.#pollAttempt();
      const client = this.#clientDataResource.hasValue() ? this.#clientDataResource.value() : undefined;
      if (
        client?.subscriptionStatus === SubscriptionStatus.Active ||
        pollAttempt >= this.MAX_SUBSCRIPTION_POLL_RELOADS
      ) {
        this.#loaderService.hideLoader();
        void this.#router.navigate(['/orders']);
        return;
      }

      this.#loaderService.showLoader();
      const retryTimer = window.setTimeout(() => {
        this.#clientDataResource.reload();
        this.#pollAttempt.update((attempt) => attempt + 1);
      }, this.SUBSCRIPTION_POLL_INTERVAL_MS);
      onCleanup(() => {
        window.clearTimeout(retryTimer);
        this.#loaderService.hideLoader();
      });
    });
  }
}
